/**
 * Registry dei moduli gioco. Cuore dell'estendibilità.
 * Aggiungere un nuovo gioco = registerGame(modulo) in main.ts.
 */

import type { GameModule } from './types';

const registry = new Map<string, GameModule<unknown, unknown>>();

export function registerGame<TState, TGuess>(mod: GameModule<TState, TGuess>): void {
  if (registry.has(mod.id)) {
    throw new Error(`Game already registered: ${mod.id}`);
  }
  registry.set(mod.id, mod as unknown as GameModule<unknown, unknown>);
}

export function getGame(id: string): GameModule<unknown, unknown> | undefined {
  return registry.get(id);
}

export function listGames(): GameModule<unknown, unknown>[] {
  return Array.from(registry.values());
}
